export function mapBeerQuizToFilters(answers = {}, profile = {}) {
  const filters = {
    category_hints: [],
    include_styles: [],
    exclude_styles: [],
    taste: [],
    bitterness: null,
    intensity: null,
    experimental: null,
  };

  // 1. Настрій
  switch (answers.mood) {
    case "light_refreshing":
      filters.include_styles.push("lager", "pilsner", "witbier", "wheat beer");
      filters.taste.push("clean", "fresh", "refreshing");
      break;

    case "fruity_juicy":
      filters.include_styles.push("hazy ipa", "pale ale", "sour", "gose");
      filters.taste.push("fruity", "juicy", "tropical", "citrus");
      break;

    case "hoppy_rich":
      filters.include_styles.push("ipa", "double ipa", "pale ale");
      filters.taste.push("hoppy", "bitter", "rich");
      filters.category_hints.push("IPA");
      break;

    case "dark_deep":
      filters.include_styles.push("stout", "porter", "dark ale");
      filters.taste.push("dark", "roasted", "chocolate", "coffee");
      break;

    case "sour_unusual":
      filters.include_styles.push("sour", "gose", "berliner weisse");
      filters.taste.push("sour", "tart", "unusual");
      filters.category_hints.push("Sour");
      break;

    case "unknown":
    default:
      break;
  }

  // 2. Інтенсивність
  switch (answers.intensity) {
    case "low":
      filters.intensity = "low";
      break;
    case "medium":
      filters.intensity = "medium";
      break;
    case "high":
      filters.intensity = "high";
      break;
    case "very_high":
      filters.intensity = "very_high";
      break;
    default:
      break;
  }

  // 3. Смак
  switch (answers.taste) {
    case "clean_fresh":
      filters.include_styles.push("lager", "pilsner", "witbier");
      filters.taste.push("clean", "fresh", "crisp");
      break;

    case "fruity":
      filters.include_styles.push("hazy ipa", "pale ale", "sour", "gose");
      filters.taste.push("fruity", "juicy", "citrus", "tropical");
      filters.category_hints.push("IPA", "Sour");
      break;

    case "bitter":
      filters.include_styles.push("ipa", "double ipa", "west coast ipa");
      filters.taste.push("bitter", "hoppy");
      filters.category_hints.push("IPA");
      break;

    case "malty":
      filters.include_styles.push("amber ale", "red ale", "bock", "brown ale");
      filters.taste.push("malty", "sweet", "caramel");
      break;

    case "sour":
      filters.include_styles.push("sour", "gose", "berliner weisse");
      filters.taste.push("sour", "tart", "acidic");
       filters.category_hints.push("Sour");
      break;

    case "roasted":
      filters.include_styles.push("stout", "porter");
      filters.taste.push("roasted", "chocolate", "coffee", "dark");
      filters.category_hints.push("Stout", "Porter");
      break;

    default:
      break;
  }

  // 4. Гіркота
  switch (answers.bitterness) {
    case "low":
      filters.bitterness = "low";
      filters.exclude_styles.push("double ipa", "west coast ipa");
      break;

    case "medium":
      filters.bitterness = "medium";
      break;

    case "high":
      filters.bitterness = "high";
      filters.include_styles.push("ipa", "west coast ipa");
      break;

    case "very_high":
      filters.bitterness = "very_high";
      filters.include_styles.push("ipa", "double ipa", "west coast ipa");
      break;

    default:
      break;
  }

  // 5. Експериментальність
  switch (answers.experimental) {
    case "safe":
      filters.experimental = "safe";
      break;

    case "medium":
      filters.experimental = "medium";
      break;

    case "interesting":
      filters.experimental = "interesting";
      break;

    case "wild":
      filters.experimental = "wild";
      filters.include_styles.push("sour", "gose", "barrel aged", "imperial stout");
      break;

    default:
      break;
  }

  return {
    intent: "beer_quiz",
    needs_products: true,
    query_rewrite: buildBeerQuizQuery(filters, profile),
    filters: normalizeFilters(filters),
    profile,
    answers,
  };
}

function normalizeFilters(filters) {
  return {
    ...filters,
    include_styles: unique(filters.include_styles),
    exclude_styles: unique(filters.exclude_styles),
    taste: unique(filters.taste),
    category_hints: unique(filters.category_hints),
  };
}

function unique(arr) {
  return [...new Set((arr || []).filter(Boolean))];
}

function sanitizeForBackend(text = "") {
  return String(text)
    .replaceAll("·", ",")
    .replace(/[^\S\r\n]+/g, " ")
    .trim();
}

function buildBeerQuizQuery(filters, profile) {
  const parts = [];

  if (profile?.taste) parts.push(profile.taste);
  if (profile?.intensity) parts.push(profile.intensity);
  if (profile?.bitterness) parts.push(profile.bitterness);
  if (profile?.experimental) parts.push(profile.experimental);

  if (filters?.include_styles?.length) {
    parts.push(filters.include_styles.slice(0, 4).join(", "));
  }

  if (filters?.taste?.length) {
    parts.push(filters.taste.slice(0, 5).join(", "));
  }

  const query = parts.length
  ? `Підібрати крафтове пиво: ${parts.join(", ")}`
  : "Підібрати крафтове пиво";

return sanitizeForBackend(query);
}